import { defineStore } from "pinia";
const useCustomerStore = defineStore("customer", {
  state: () => ({
    user: null,
    isLoggedIn: false
  }),
  actions: {
    setIsLoggedIn(isLoggedIn) {
      this.isLoggedIn = isLoggedIn;
    }
  },
  getters: {
    isCompanyCustomer: (state) => {
      var _a;
      return !!((_a = state.user) == null ? void 0 : _a.company_id);
    }
  }
});
export {
  useCustomerStore
};
